<template>
  <div class="menu-iframe">
    <div v-if="loading" class="menu-iframe__loading">
      <img class="menu-iframe__loading-img" :src="loadingGif" alt="loading" />
    </div>
    <iframe
      ref="iframe"
      class="menu-iframe__frame"
      frameborder="0"
      allow="microphone"
      :src="url"
      @load="loading = false"
    ></iframe>
  </div>
</template>

<script>
import loadingGif from '@/assets/cosmo_loading.gif'

/**
 * 菜单 iframe 页面容器：用于数字人广场/知识库等菜单通过 iframe 嵌入的整页。
 * 与对话内多 iframe 组件（IframeContainer，带右上角 tab 切换）相互独立、不混用。
 * 只渲染单个 iframe，不维护多 iframe 列表、不做持久化、不提供 tab 切换。
 * iframe 加载期间显示 cosmo_loading.gif 加载动画，加载完成后隐藏。
 */
export default {
  name: 'MenuIframe',
  props: {
    url: { type: String, required: true },
    name: { type: String, default: '' }
  },
  data() {
    return {
      loading: true,
      loadingGif
    }
  },
  watch: {
    url() {
      this.loading = true
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-iframe {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  border-radius: 12px;
}

.menu-iframe__loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.menu-iframe__loading-img {
  width: 282px;
  object-fit: contain;
}

.menu-iframe__frame {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
